module.exports = __webpack_public_path__ + "static/media/noDrones.32766da3.png";